<template>
  <div id="app">
      <router-view></router-view>
      <Footer/>
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status:0
    };
  },
  methods: {
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        if (res && res.code === 200) {
          this.$store.commit('setBaseInfoValue', res.data);
        }
      })
    }

  },
  created(){
    this.getBaseInfo();
  }
}
</script>

<style>
body .van-toast {
  font-size: 38px;
  padding: 30px;
  line-height: 50px;
  width: 500px;
  background: linear-gradient(#1d1610, #3b2818) !important;
}
body .van-toast .van-toast__icon {
  font-size: 50px;
}
body .van-dialog {
  width: 560px;
  border-radius: 24px;
}
body .van-dialog__header {
  padding-top: 40px;
  font-size: 34px;
  line-height: 1.4;
}
body .van-dialog__message {
  padding: 28px 36px;
  font-size: 28px;
  line-height: 1.5;
}
body .van-dialog__footer {
  height: 96px;
}
body .van-dialog__cancel,
body .van-dialog__confirm {
  font-size: 30px;
  height: 96px;
  line-height: 96px;
}
body .van-action-sheet__item,
body .van-action-sheet__cancel {
  font-size: 26px;
  line-height: 1.4;
  padding: 20px 16px;
}
body .van-action-sheet__gap {
  height: 12px;
}
body .van-action-sheet__header {
  font-size: 26px;
  height: 80px;
  line-height: 80px;
}
body .van-action-sheet__close {
  font-size: 36px;
  padding: 0 24px;
}
*, :after, :before {
  box-sizing: border-box;
}
</style>
